// extracted by mini-css-extract-plugin
export default {"faqSection":"Faq_faqSection__cYWhf","faq":"Faq_faq__hMFXF","faqHead":"Faq_faqHead__YuptD","openClose":"Faq_openClose__pjpp4"};